import { useRef, useState } from 'react';
import { dataPremium } from 'data/generalOutline';

const PremiumSection = () => {
  const mainImageRef = useRef<HTMLDivElement>(null);
  const isInitHeightSetting = useRef<boolean>(false);
  const [activeBg, setActiveBg] = useState<Number>(1);

  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if (!isInitHeightSetting.current && mainImageRef.current) {
      isInitHeightSetting.current = true;

      const mainImageElement = mainImageRef.current;
      const percent = (e.currentTarget.height / mainImageElement.clientWidth) * 100;

      mainImageElement.style.paddingBottom = `${percent}%`;
    }
  };

  const renderActiveBg = () => {
    return dataPremium.map((v, idx) => {
      const isActive = idx + 1 === activeBg;
      return <img key={v.tit} onLoad={e => onImageLoad(e)} className={isActive ? '' : 'deactive'} src={v.img} alt="" />;
    });
  };

  const handleChageActiveBg = (bgNum: Number) => {
    setActiveBg(bgNum);
  };

  return (
    <div id="premium" className="premium-info">
      <div className="premium-bg" ref={mainImageRef}>
        <div className="opa-bg"></div>
        {renderActiveBg()}

        <div className="premium-list">
          {dataPremium.map((sp, index) => {
            return (
              <div
                key={index}
                onMouseLeave={() => handleChageActiveBg(index + 1)}
                onMouseEnter={() => handleChageActiveBg(index + 1)}
                className={`${activeBg === index + 1 ? 'on' : ''} premium-items`}>
                <div className="premium-items-bg"></div>
                <div className="text-area">
                  <div className="sub-title">{sp.subtit}</div>
                  <div className="title">{sp.tit}</div>
                  <div className="detail">{sp.detail}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PremiumSection;
